import PortalIdParser from 'PortalIdParser';
import { getIsHelpDesk } from './getIsHelpDesk';
export const getInboxRootUrl = () => `/live-messages/${PortalIdParser.get()}`;
export const getHelpdeskRootUrl = () => {
  return `/helpdesk/${PortalIdParser.get()}`;
};
export const getRootUrl = () => {
  const baseUrl = getIsHelpDesk() ? '/helpdesk' : '/live-messages';
  return `${baseUrl}/${PortalIdParser.get()}`;
};